import { render, staticRenderFns } from "./Exhistory.vue?vue&type=template&id=36af3d15&scoped=true&"
import script from "./Exhistory.vue?vue&type=script&lang=js&"
export * from "./Exhistory.vue?vue&type=script&lang=js&"
import style0 from "./Exhistory.vue?vue&type=style&index=0&id=36af3d15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af3d15",
  null
  
)

export default component.exports